import ResultCard from './ResultCard'

export default ResultCard